var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPesquisaAva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3B-Liner_Desktop_Home_Escuro",
    transform: "translate(-887.000000, -764.000000)",
    stroke: "",
    strokeWidth: 1.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "mn-copy-3",
    transform: "translate(645.000000, 633.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-57",
    transform: "translate(243.039097, 131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pesquisa_ava",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.46090253,
    cy: 6.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68895724,14.0418613 L0.00276387502,11.3501402",
    id: "Vector",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    transform: "translate(1.345861, 12.696001) rotate(-270.000000) translate(-1.345861, -12.696001) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.48358305,
    y1: 3.38817648,
    x2: 7.48358305,
    y2: 9.64456912,
    id: "Line-3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.49364812,
    y1: 3.40554156,
    x2: 7.49364812,
    y2: 9.62720403,
    id: "Line-3-Copy",
    strokeLinecap: "round",
    transform: "translate(7.493648, 6.516373) rotate(-90.000000) translate(-7.493648, -6.516373) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPesquisaAva);
export default __webpack_public_path__ + "static/media/pesquisa_ava.93b90abd47f5e304c17eff37bd214f87.svg";
export { ForwardRef as ReactComponent };